import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, generateUrl: String }
  static targets = ["label"]

  async share() {
    let url = this.urlValue

    if (!url && this.generateUrlValue) {
      const response = await this.generateToken()
      if (!response) return
      url = response.data.url
      this.urlValue = url
    }

    if (navigator.share) {
      try {
        await navigator.share({ title: "Check out this recipe!", url })
        return
      } catch { /* user cancelled */ }
    }

    await this.copyToClipboard(url)
  }

  async generateToken() {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.generateUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token, "Accept": "application/json" }
    })
    if (!response.ok) return null
    return response.json()
  }

  async copyToClipboard(url) {
    try {
      await navigator.clipboard.writeText(url)
    } catch {
      const ta = document.createElement("textarea")
      ta.value = url
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      document.execCommand("copy")
      ta.remove()
    }

    if (this.hasLabelTarget) {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = "Link copied!"
      setTimeout(() => { this.labelTarget.textContent = original }, 2000)
    }
  }
}
